export const FETCH_ABSENT_EMPLOYEE_REQUEST = "FETCH_ABSENT_EMPLOYEE_REQUEST";
export const FETCH_ABSENT_EMPLOYEE_SUCCESS = "FETCH_ABSENT_EMPLOYEE_SUCCESS";
export const FETCH_ABSENT_EMPLOYEE_FAILURE = "FETCH_ABSENT_EMPLOYEE_FAILURE";

export const FETCH_ABSENT_EMPLOYEE_LOCATION_REQUEST = "FETCH_ABSENT_EMPLOYEE_LOCATION_REQUEST";
export const FETCH_ABSENT_EMPLOYEE_LOCATION_SUCCESS = "FETCH_ABSENT_EMPLOYEE_LOCATION_SUCCESS";
export const FETCH_ABSENT_EMPLOYEE_LOCATION_FAILURE = "FETCH_ABSENT_EMPLOYEE_LOCATION_FAILURE";